export const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

export const CATEGORIES = [
  { key: "PROJECT", label: "Projects" },
  { key: "SERVICE", label: "Services" },
  { key: "OTHER", label: "Other Revenue" },
];

export const CATEGORY_FY_KEY = { PROJECT: "projects_fy", SERVICE: "services_fy", OTHER: "other_fy" };

export const fmtSEK = (v) =>
  v == null ? "—" : `${new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 }).format(Math.round(v))}`;

export const g = (obj, m) => obj?.[m] ?? obj?.[String(m)];
